import React from "react";
import SearchImage from "../../assets/search.png";
import { Container, SearchIcon } from "../../styles/search/searchbar";

const SearchBar = ({ getGeoCode, keywordChange, search }) => {
  return (
    <Container>
      <span className="content">
        <input
          defaultValue={search}
          placeholder="Search"
          onChange={keywordChange}
        />
        <SearchIcon alt="search icon" src={SearchImage} onClick={getGeoCode} />
      </span>
    </Container>
  );
};

export default SearchBar;
